import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";
import templateUrl from "emun.retailer/retailer-shipping-location-delete-prompt.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import LocationPicker from "emun.cust/locations/picker/location-picker";

export default class RetailerShippingLocationDeletePromptController {
  constructor(options, $uibModalInstance) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.$dismiss = $ctrl.dismiss = $uibModalInstance.dismiss;
  	$ctrl.bus = new ServiceBus();
    $ctrl.shippingLocation = options.shippingLocation;
    $ctrl.title = options.title || "Delete Shipping Location";
    $ctrl.request = {};
    Object.assign($ctrl.request, $ctrl.shippingLocation);
    $ctrl.bus.send(`QueryCartsJoin.json?Take=1&IsActive=1&RetailerId=${$ctrl.shippingLocation.retailerId}&ShipId=${$ctrl.shippingLocation.id}`).then(function(res) {
      if (res.data.results.length) $ctrl.hasOrders = true;
    })
    $ctrl.bus.send(`QueryRetailers.json?Id=${$ctrl.shippingLocation.retailerId}`).then(function(res) {
      if (res.data.results.length) $ctrl.customer = res.data.results[0];
    })
    $ctrl.save = $ctrl.submit = function() {
      let $ctrl = this;
      if ($ctrl.request.DestinationRetailerId && $ctrl.request.DestinationShipId) {
        $ctrl.request.transferOrders = true;
        $ctrl.request.permanentlyRemove = true;
      }
      $ctrl.bus.send("DeleteRetailerShippingLocation.json", $ctrl.request).then(function(res) {
        modals.alert("Shipping location removed succesfully");
        $ctrl.$broadcast("ShippingLocationDeleted");
        $ctrl.$dismiss();
      });
    };
    $ctrl.selectRetailer({id: $ctrl.shippingLocation.retailerId});
  }
  findRetailers(val) {
    let $ctrl = this;
    let url = `/QueryRetailersSearch.json?Take=5&Status=Active&Search=${val}&OrderBy=CompanyName`; //
    console.log("QueryRetailersSearch.$item", url);
    return $ctrl.bus.send(url).then(res => res.data.results);
  }
  selectRetailer(val) {
    const $ctrl = this;
    $ctrl.request.DestinationRetailerId = val.id;
  }
  selectLocation() {
    const $ctrl = this;
		return LocationPicker({
			title: "Select Shipping Location...",
			subTitle: "",
			applyTagsButtonText: false,
			single: true,
      criteria: {
        RetailerId: $ctrl.request.DestinationRetailerId
      },
			viewSelections: false, 
		}).then((result) => {
      $ctrl.selectedLocation = result;
      $ctrl.request.DestinationShipId = result.id;
		});
  }
}

